<template>
      <table class="footable table table-bordered table-striped table-highlight">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nome</th>
            <th class="tcenter">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{user.id}}</td>
            <td>{{user.name}}</td>
            <td class="tcenter">
              <div v-if="removeItem!=user.id">
                <button v-on:click="resetFaceAuthentic(user)" class="btn btn-default md">
                  FaceID Reset
                  <i class="fa fa-edit"></i>
                </button>
                <button v-on:click="loadUserPage(user)" class="btn btn-default md">
                  Editar
                  <i class="fa fa-edit"></i>
                </button>
                <a v-on:click="removeItem=user.id" class="btn btn-default md">
                  Remover
                  <i class="fa fa-trash"></i>
                </a>
              </div>
              <div class="parent" v-else>
                <p class="child">Tem certeza que deseja remover o usuário selecionado?</p>
                <a v-on:click="removeItem=0" class="child btn btn-danger md">Cancelar</a>
                <a v-on:click="removeSubscription(user)" class="child btn btn-success md">Confirmar</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
</template>


<script>
import axios from "axios";
import Alert from "../Alert";

axios.defaults.withCredentials = true;

export default {
  props: ["product"],
  data() {
    return {
      addBookForm: {},
      users: [],
      removeItem: 0
    };
  }, 
  components: {
    alert: Alert
  },
  methods: {
    resetFaceAuthentic(user){
      
      const path = this.$global.endpoint + "/user/admin/reset";
      
       axios
        .post(path, { user: user })
        .then(res => {
         this.$notify({
            type: "success",
            group: "foo",
            title: "Authenticação Resetada"
          });
        })
        .catch(error => {
          console.error(error);
        });
    },
    loadUserPage(user) {
      this.$store.commit("change_user_edit", user);
      this.$router.push({ name: "edituser", params: { previous: 'editproduct' } });
    },
    removeSubscription(user) {
      const path = this.$global.endpoint + "/subscription/remove/noPaymentId";

      axios
        .post(path, {
          productId: this.product.id,
          userId: user.id
        })
        .then(res => {
          
          this.getProductSubscriptions();

          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Inscrição removida"
          });
          this.deleteLoading = false;
          this.deleteSubscription = null;
          this.$emit("update");
        })
        .catch(error => {
          this.deleteLoading = false;
          this.deleteSubscription = null;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao remover a inscrição"
          });
        });
    },

    getProductSubscriptions(){
console.log('productId', this.product.id)
      const path = this.$global.endpoint + "/user/admin/getall/product";

      axios
        .post(path, { productId: this.product.id })
        .then(res => {
          this.users = res.data;
          this.$emit("update");
          this.loadingSubscriptions = false;
        })
        .catch(error => {
          this.loadingSubscriptions = false;
          console.error(error);
        });
    }
  },
  created() {
    this.getProductSubscriptions();
  }
};
</script>











